interface CategoryFilterProps {
  active: string;
  onChange: (cat: string) => void;
  search: string;
  onSearch: (val: string) => void;
  categories: string[];
  loading: boolean;
}

export default function CategoryFilter({ active, onChange, search, onSearch, categories, loading }: CategoryFilterProps) {
  return (
    <div className="bg-white border-b border-slate-100 lg:sticky lg:top-[104px] z-30">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6 py-4">
        <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
          {/* Categories */}
          <div className="flex flex-wrap gap-2">
            {loading ? (
              <div className="h-7 w-24 bg-slate-100 rounded-full animate-pulse" />
            ) : (
              categories.map((cat) => {
                const isActive = cat === "Todas" ? !active : active === cat;
                return (
                  <button
                    key={cat}
                    onClick={() => onChange(cat)}
                    className={`px-4 py-1.5 text-xs font-inter font-semibold rounded-full transition-all cursor-pointer whitespace-nowrap ${
                      isActive
                        ? "bg-blue-600 text-white"
                        : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                    }`}
                  >
                    {cat}
                  </button>
                );
              })
            )}
          </div>
          {/* Search */}
          <div className="relative w-full sm:w-56">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm" />
            <input
              type="text"
              value={search}
              onChange={(e) => onSearch(e.target.value)}
              placeholder="Buscar noticias..."
              className="w-full pl-9 pr-4 py-2 bg-slate-100 rounded-lg text-sm font-inter text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-300"
            />
          </div>
        </div>
      </div>
    </div>
  );
}